export default __webpack_public_path__ + "static/media/home_page_power_play.2d881ba7.png";